import styled from 'styled-components';

export const StyledForm = styled.div`
  &[dir='rtl'] {
    .css-319lph-ValueContainer {
      justify-content: flex-start;
    }
    .dropdown__single-value {
      display: flex;
    }
    .dropdown__placeholder {
      display: flex;
    }
  }

  .react-datepicker {
    position: relative;
  }

  .react-datepicker__input {
    max-height: 3.125rem !important;
  }

  .is-current-or-prev-month {
    & > .react-datepicker__navigation--previous {
      display: none !important;
    }
  }

  .react-datepicker__wrapper {
    position: relative;
    margin: 0.6rem 0;
    z-index: 9;
  }

  .react-datepicker__triangle {
    transform: rotate(180deg) !important;
    left: 1rem !important;
    bottom: -0.325rem !important;

    &:after {
      border-bottom-color: #fff !important;
      border-width: 6px !important;
    }

    &:before {
      border-width: 6px !important;
    }
  }

  .react-datepicker-popper {
    width: fit-content;
    height: 100% !important;
    transform: translate(0px, -13.25rem) !important;
    border-radius: 2px;
  }

  .react-datepicker__year--container,
  .react-datepicker__month-container {
    width: fit-content;
    height: 100% !important;
  }

  .react-datepicker__month-wrapper {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-evenly;
    padding-bottom: 5px;
  }

  .react-datepicker__current-month {
    width: 145px;
    margin-right: auto;
    margin-left: auto;
    height: 22px;
    border-radius: 4px;
    &:hover {
      background: #eee;
    }
  }
  .react-datepicker__year-wrapper {
    width: 100%;
    height: 100%;
  }

  .react-datepicker__month {
    font-family: 'DINRegular', sans-serif;
    margin-top: 1.5rem;
  }

  .react-datepicker__year {
    font-family: 'DINRegular', sans-serif;
    margin: 0;
  }

  .react-datepicker__week {
    font-family: 'DINRegular', sans-serif;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
  }

  .react-datepicker__day {
    font-family: 'DINRegular', sans-serif;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.8125rem;
    height: 1.375rem;
    cursor: pointer;
    &:first-child,
    &:last-child {
      width: 1.25rem;
    }
  }
  .react-datepicker__day--next-month,
  .react-datepicker__day--prev-month,
  .react-datepicker__day--prev-day {
    color: #999999;
  }

  .react-datepicker__day--keyboard-selected {
    color: #fff !important;
    background-image: linear-gradient(to bottom, #08c, #04c);
    background-repeat: repeat-x;
    width: 1.8125rem;
  }
  .react-datepicker__day--next-day {
  }
  .react-datepicker__day-name {
    font-family: 'DINRegular', sans-serif;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    width: 1.8125rem;
    height: 1.375rem;
    margin: 0;
    &:first-child,
    &:last-child {
      width: 1.25rem;
    }
  }

  .react-datepicker__navigation {
    border: none;
    outline: none;
    background: transparent;
    width: fit-content;
    min-width: 0;
    &:hover {
      background: transparent;
    }
  }

  .react-datepicker__navigation-icon:before {
    border-color: #000;
    border-style: solid;
    border-width: 1px 1px 0 0;
    content: '';
    display: block;
    height: 4px;
    position: absolute;
    top: 6px;
    width: 4px;
  }

  .react-datepicker__navigation-icon--next:before {
    &:hover {
      border-color: #212529;
    }
  }
  .react-datepicker__navigation-icon--next:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 34%;
    width: 4px;
    height: 4px;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
    transform: translate(66%, -50%) rotate(315deg);
    &:hover {
      border-color: #212529;
    }
  }

  .react-datepicker__navigation--next {
    transform: translateX(4.75rem) !important;
    width: 20px;
    height: 22px;
    padding: 0;
    position: relative;
    &:before {
      content: '';
      position: absolute;
      top: 50%;
      right: 50%;
      width: 4px;
      height: 4px;
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
      transform: translate(50%, -50%) rotate(315deg);
    }
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      right: 38%;
      width: 4px;
      height: 4px;
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
      transform: translate(62%, -50%) rotate(315deg);
    }
    & > span {
      opacity: 0;
    }
  }
  .react-datepicker__navigation--previous {
    transform: translateX(-6rem) !important;
    width: 20px;
    height: 22px;
    padding: 0;
    position: relative;
    &:before {
      content: '';
      position: absolute;
      top: 50%;
      right: 38%;
      width: 4px;
      height: 4px;
      border-left: 1px solid #000;
      border-top: 1px solid #000;
      transform: translate(62%, -50%) rotate(315deg);
    }
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      right: 50%;
      width: 4px;
      height: 4px;
      border-left: 1px solid #000;
      border-top: 1px solid #000;
      transform: translate(50%, -50%) rotate(315deg);
    }
    & > span {
      opacity: 0;
    }
  }
  .react-datepicker__navigation:hover *::before {
    border-color: #212529;
    &:hover {
      border-color: #212529;
    }
  }
  .react-datepicker__navigation-icon--previous:after {
    border-color: #212529;
    border-style: solid;
    border-width: 1px 1px 0 0;
    content: '';
    display: block;
    height: 4px;
    position: absolute;
    top: 6px;
    width: 4px;
    transform: rotate(225deg) translate(-4.5px, 4.5px);
    &:hover {
      border-color: #212529;
    }
  }

  .react-datepicker__header:hover {
    background-color: #fefefe !important;
  }

  .react-datepicker__header {
    font-family: 'DINRegular';
    font-size: 13px;
    background-color: #fff;
    border-bottom: none;
    padding: 0;
    position: relative;
    cursor: pointer;
    width: 100%;
    height: 1.5rem;
    margin: 0.325rem auto;
    border-radius: 2px;
    &[dir='rtl'] {
      font-family: GESSTwoDWTCLight, sans-serif;
    }
  }

  .react-datepicker__year-text,
  .react-datepicker__month-text {
    padding: 1.0625rem 0 !important;
    width: 2.5rem !important;
    font-family: 'DINRegular';
    font-size: 13px;
    font-weight: 400;
    margin: 0 !important;
    z-index: 1;
    position: relative;
    &[dir='rtl'] {
      font-family: GESSTwoDWTCLight, sans-serif;
    }
  }

  .react-datepicker__year-text--selected,
  .react-datepicker__year-text--keyboard-selected,
  .react-datepicker__month--selected,
  .react-datepicker__month-text--keyboard-selected {
    background: rgb(73, 156, 215);
    background: linear-gradient(180deg, rgba(73, 156, 215, 1) 0%, rgba(0, 69, 204, 1) 100%);
  }

  .react-datepicker__year-wrapper {
    display: flex;
    flex-wrap: wrap;
    max-width: 180px;
    flex-direction: row;
    align-content: center;
    justify-content: space-evenly;
    align-items: center;
  }

  .dropdown__input-container {
    opacity: 0;
  }

  .dropdown__control {
    border-radius: 0;
    width: 100%;
    height: 3.125rem;
    box-shadow: none;
    outline: none;
    text-align: left;
    line-height: 1.5;
    text-align: ${({ isArabic }) => (isArabic ? 'right' : 'left')};
    font-family: ${({ isArabic }) => (isArabic ? 'GESSTwoDWTCMedium' : 'DINRegular')};
    font-size: ${({ isArabic }) => (isArabic ? '10px' : '0.875rem')};
    caret-color: transparent;
    padding: 0 1rem;
    border: 1px solid ${({ isOpen }) => (isOpen ? '#dae0e5' : 'transparent')};
    cursor: pointer;
    background-color: #fff;
    &:hover {
      border: 1px solid #dae0e5;
    }

    &:after {
      content: '';
      margin-left: ${({ isArabic }) => (isArabic ? '0' : '1rem')};
      margin-right: ${({ isArabic }) => (isArabic ? '1rem' : '0')};
      display: inline-block;
      margin-bottom: 3px;
      width: 0;
      height: 0;
      border: solid #000;
      border-width: 0 2px 2px 0;
      padding: 3px;
      animation-name: ${({ isOpen }) => (isOpen ? 'arrow-up' : 'arrow-down')};
      animation-duration: 300ms;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
    }

    @keyframes arrow-up {
      from {
        transform: rotate(-315deg);
      }
      to {
        transform: rotate(-135deg);
      }
    }

    @keyframes arrow-down {
      from {
        transform: rotate(-135deg);
      }
      to {
        transform: rotate(45deg);
      }
    }
  }
  .dropdown__indicator-separator,
  .dropdown__indicator {
    display: none;
  }
  .dropdown__menu {
    width: 100%;
    height: auto;
    box-shadow: none;
    border: 1px solid #dae0e5;
    position: absolute;
    top: 3.25rem;
    margin: 0;
    background-color: #fff;
    z-index: 10;
    ${({ isOpen }) =>
      isOpen
        ? `
      animation-name: fade-in;
      animation-duration: 300ms;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
      `
        : `
      animation-name: fade-out;
      animation-duration: 300ms;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
      `}
  }
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fade-out {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .dropdown__menu-list {
    padding: 0;
    width: 100%;
    height: 100%;
    max-height: 20rem;
  }
  .dropdown__option {
    width: 100%;
    height: 1.75rem;
    margin: 0.75rem auto;
    font-size: ${({ isArabic }) => (isArabic ? '0.75rem' : '0.875rem')};
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #212529;
    background-color: #fff;
    padding: 0 1.25rem;
    cursor: pointer;
    &:active,
    &:focus {
      background-color: #fff;
    }
    &:hover {
      background-color: #f8f9fa;
      color: #1b7bdd;
    }
  }
  .dropdown__option--is-selected {
    color: #fff !important;
    background-color: #1b7bdd !important;
  }

  .dropdown__single-value,
  .dropdown__placeholder {
    color: ${({ isOpen }) => (!isOpen ? '#898989' : '#898989')} !important;
    text-transform: uppercase;
    font-size: 14px;
    @media (min-width: 1200px) {
      font-size: 10px;
    }
  }
  .dropdown__value-container {
    padding: 0;
  }

  &[dir='ltr'] {
    .Form {
      .checkbox-container {
        & > div {
          margin: 0.75rem 1rem 0 0;
          padding-left: 1.5rem;

          label {
            &:before {
              left: 0;
            }
            &:after {
              left: 0;
            }
          }
        }
      }
    }
  }

  &[dir='rtl'] {
    .Form {
      .checkbox-container {
        & > div {
          margin: 0.75rem 0 0 1rem;
          padding-right: 1.5rem;

          label {
            &:before {
              right: 0;
            }
            &:after {
              right: 0;
            }
          }
        }
      }
    }
  }

  .Form {
    .checkbox-container {
      & > div {
        position: relative;

        input {
          position: absolute;
          z-index: -1;
          opacity: 0;

          &:checked {
            & ~ label {
              &:before {
                background-color: #007bff;
                color: #fff;
              }
              &:after {
                background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
              }
            }
          }
        }

        label {
          margin-top: 3px !important;
          font-size: 14px;
          line-height: 17px;

          &[dir='ltr'] {
            letter-spacing: 1.5px;
          }

          &:before {
            border-radius: 0.25rem;
            position: absolute;
            top: 0.25rem;
            display: block;
            width: 1rem;
            height: 1rem;
            pointer-events: none;
            content: '';
            user-select: none;
            background-color: #dee2e6;
          }

          &:after {
            position: absolute;
            top: 0.25rem;
            display: block;
            width: 1rem;
            height: 1rem;
            content: '';
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 50% 50%;
          }
        }
      }

      @media (min-width: 768px) {
        display: flex;
        flex-wrap: wrap;
        width: 100%;

        & > div {
          max-width: calc(50% - 1rem);
          flex: 0 0 calc(50% - 1rem);
        }
      }
    }

    .Form-page {
      margin-bottom: 20px;
    }

    .Form-fieldset {
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      border: 0;
      column-gap: 20px;
    }

    .Form-column {
      grid-column: 1 / -1;
    }

    .Form-column[data-columns='1'] {
      grid-column: span 1;
    }

    .Form-column[data-columns='2'] {
      grid-column: span 2;
    }

    .Form-column[data-columns='3'] {
      grid-column: span 3;
    }

    .Form-column[data-columns='4'] {
      grid-column: span 4;
    }

    .Form-column[data-columns='5'] {
      grid-column: span 5;
    }

    .Form-column[data-columns='6'] {
      grid-column: span 6;
    }

    .Form-column[data-columns='7'] {
      grid-column: span 7;
    }

    .Form-column[data-columns='8'] {
      grid-column: span 8;
    }

    .Form-column[data-columns='9'] {
      grid-column: span 9;
    }

    .Form-column[data-columns='10'] {
      grid-column: span 10;
    }

    .Form-Column[data-columns='11'] {
      grid-column: span 11;
    }

    .Form-Column[data-columns='12'] {
      grid-column: span 12;
    }

    .Form-fieldGroup {
      padding: 0.75rem 0;
      margin: 0;

      label {
        font-size: 14px;
        line-height: 17px;
        letter-spacing: 1.5px;
        display: inline-block;
        margin-bottom: 0.5rem;
        vertical-align: unset;
        border-color: transparent;
        border-radius: 0;
      }

      button,
      option,
      input,
      textarea,
      select {
        font-family: inherit;
      }

      button,
      option,
      input[type='text'],
      input[type='password'],
      input[type='email'],
      input[type='tel'],
      input[type='number'],
      textarea,
      select {
        margin: 0;
      }

      select,
      textarea,
      input {
        border-radius: 0;
        text-transform: uppercase;
        padding: 18px 20px;
        font-size: 10px;
        border: 0;
        letter-spacing: 1.82px;
        background-color: #fff;
        color: #000;
        width: 100%;
        line-height: 1.5;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

        &:focus {
          box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
          border-color: #80bdff;
          outline: 0;
          outline-color: transparent;
        }

        &:hover {
          border-color: #2a8dd4;
        }
      }

      input[type='checkbox'] {
        width: auto;
      }

      select {
        position: relative;

        &:after {
          content: '';
          border: solid black;
          border-width: 0 1px 1px 0;
          display: inline-block;
          padding: 3px;
          transform: rotate(45deg);
          position: absolute;
          right: 0;
          top: 0;
        }
      }

      textarea {
        height: 300px;
      }
    }

    .Form-fieldGroup label:nth-child(1) {
      display: block;
    }

    .Form-fieldGroup h1,
    .Form-fieldGroup p {
      margin: 10px 0 0;
    }

    .Form-fieldGroup p {
      white-space: pre;
    }

    .Form-fieldGroup span:last-child {
      color: #dc3545;
      display: block;
    }

    .Form-fieldGroup {
      &label {
        display: inline-block;
        margin-bottom: 5px;
        line-height: 24px;
        font-size: 14px;
        letter-spacing: 1.5px;
      }
      &input[type='date'],
      &input[type='password'],
      &input[type='text'],
      &select,
      &textarea {
        width: 100%;
        min-width: 245px;
        border-radius: 0;
        text-transform: uppercase;
        padding: 18px 20px;
        font-size: 10px;
        border: 0;
        letter-spacing: 1.82px;
        background-color: #fff;
        color: #000;
        &:focus {
          outline: 0;
          border-color: #bbbbbb;
          box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
        }
      }

      &textarea {
        min-height: 350px;
      }

      &select {
        border-radius: 0;
        text-transform: uppercase;
        padding: 18px 20px;
        font-size: 10px;
        border: 0;
        letter-spacing: 1.82px;
        background-color: #fff;
        color: #000;
        height: calc(3.063rem + 2px) !important;
      }
    }
  }
`;
